function cardVariantSelects() {
  return Array.from(document.querySelectorAll('.quick-add select[data-card-variant-selector]'));
}

function isVisibleCardSelect(select) {
  if (!select || select.disabled) return false;
  const style = window.getComputedStyle(select);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  const rect = select.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

function syncCardVariantSelectors() {
  const seen = new Set();

  cardVariantSelects().forEach(function (select) {
    const visible = isVisibleCardSelect(select);
    select.tabIndex = visible ? 0 : -1;
    if (visible) {
      select.removeAttribute('aria-hidden');
    } else {
      select.setAttribute('aria-hidden', 'true');
    }

    if (select.dataset.cardVariantKeys) return;
    select.dataset.cardVariantKeys = 'true';
    select.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.stopPropagation();
    });
    select.addEventListener('focus', function () {
      if (isVisibleCardSelect(select) || !select.id || seen.has(select)) return;
      const match = cardVariantSelects().find(function (candidate) {
        return candidate.id === select.id && isVisibleCardSelect(candidate);
      });
      if (!match || match === select) return;
      seen.add(select);
      match.focus();
      seen.delete(select);
    });
  });
}

document.addEventListener('change', function (event) {
  const selector = event.target.closest('[data-card-variant-selector]');
  if (!selector) return;

  const card = selector.closest('[data-product-card-root]');
  if (!card) return;

  const selectedOption = selector.options[selector.selectedIndex];
  if (!selectedOption) return;

  const price = selectedOption.dataset.price || '';
  const compareAtPrice = selectedOption.dataset.compareAtPrice || '';
  const discountPercentage = selectedOption.dataset.discountPercentage || '';
  const available = selectedOption.dataset.available === 'true';

  const priceContainer = card.querySelector('[data-card-price-wrapper] .price');
  const regularPrice = card.querySelector('[data-card-price-wrapper] .price__regular .price-item--regular');
  const salePrice = card.querySelector('[data-card-price-wrapper] .price__sale .price-item--sale');
  const comparePrice = card.querySelector('[data-card-price-wrapper] .price__sale .price-item--regular');
  const discountPrice = card.querySelector('[data-card-price-wrapper] [data-price-discount]');
  const submitButton = card.querySelector('[data-card-variant-submit]');
  const buttonText = card.querySelector('[data-card-variant-button-text]');

  if (regularPrice) regularPrice.textContent = price;
  if (salePrice) salePrice.textContent = price;
  if (comparePrice) comparePrice.textContent = compareAtPrice;

  if (discountPrice) {
    const sr = discountPrice.querySelector('[data-price-discount-sr]');
    const visible = discountPrice.querySelector('[data-price-discount-visible]');
    if (discountPercentage && sr && visible) {
      sr.textContent = `${discountPercentage} percent off`;
      visible.textContent = `-${discountPercentage}% OFF`;
    } else if (discountPercentage) {
      discountPrice.textContent = `-${discountPercentage}% OFF`;
    } else if (sr && visible) {
      sr.textContent = '';
      visible.textContent = '';
    } else {
      discountPrice.textContent = '';
    }

    discountPrice.hidden = !discountPercentage;
  }

  if (priceContainer) {
    priceContainer.classList.toggle('price--on-sale', Boolean(compareAtPrice));
    priceContainer.classList.toggle('price--sold-out', !available);
  }

  if (submitButton) submitButton.disabled = !available;

  if (buttonText) {
    buttonText.textContent = available
      ? window.productCardStrings.addToCart
      : window.productCardStrings.soldOut;
  }

  const idInput = selector.form && selector.form.querySelector('[data-card-variant-id]');
  if (idInput && selectedOption.dataset.variantId) idInput.value = selectedOption.dataset.variantId;
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncCardVariantSelectors);
} else {
  syncCardVariantSelectors();
}

document.addEventListener('shopify:section:load', syncCardVariantSelectors);

let cardVariantSyncFrame = 0;
new MutationObserver(function () {
  if (cardVariantSyncFrame) return;
  cardVariantSyncFrame = window.requestAnimationFrame(function () {
    cardVariantSyncFrame = 0;
    syncCardVariantSelectors();
  });
}).observe(document.documentElement, { childList: true, subtree: true });